package floris.graphics.landing.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.columnGap
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.navigation.Anchor
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import floris.graphics.core.navigation.Navigation
import com.materialdesignsystem.components.svg.instagramSvg
import com.materialdesignsystem.components.svg.linkedInSvg
import com.materialdesignsystem.components.svg.youtubeSvg
import com.materialdesignsystem.components.widgets.DsBorderRadius
import com.materialdesignsystem.components.widgets.FilledTonalIconButton
import com.materialdesignsystem.constants.AttributeValue
import com.materialdesignsystem.constants.Attributes
import com.materialdesignsystem.toColorScheme
import org.jetbrains.compose.web.css.px

@Composable
fun Socials(modifier: Modifier = Modifier) {
    val iconColor = ColorMode.current.toColorScheme.onSecondaryContainer
    val iconModifier = Modifier.size(20.px)

    Row(
        modifier = modifier.columnGap(12.px),
        horizontalArrangement = Arrangement.End
    ) {
        SocialButton(
            href = Navigation.External.Instagram.route,
            icon = {
                instagramSvg(modifier = iconModifier, fill = iconColor)
            }
        )

        SocialButton(
            href = Navigation.External.LinkedIn.route,
            icon = {
                linkedInSvg(modifier = iconModifier, fill = iconColor)
            }
        )

        SocialButton(
            href = Navigation.External.Youtube.route,
            icon = {
                youtubeSvg(modifier = iconModifier, fill = iconColor)
            }
        )
    }
}

@Composable
private fun SocialButton(
    href: String,
    icon: @Composable () -> Unit,
    modifier: Modifier = Modifier,
) {
    Anchor(
        attrs = modifier
            .toAttrs {
                attr(Attributes.Target, AttributeValue.Blank)
                attr(Attributes.Rel, AttributeValue.NoReferrer)
            },
        href = href,
    ) {
        FilledTonalIconButton(
            modifier = Modifier.size(36.px),
            size = ButtonSize.MD,
            borderRadius = DsBorderRadius(6.px),
            onClick = {},
            content = { icon() }
        )
    }
}
